module.exports = __webpack_public_path__ + "static/media/Inter-Regular.f10cf35d.woff";